import styled from 'styled-components';
import { Button, Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP, BP_TABLET } from '@rsos/constants/breakpoints';

export const SearchBarWrapper = styled(Box).attrs(() => ({
  horizontal: true,
  position: 'relative',
  justify: 'center',
  padding: '16px 12px',
  backgroundColor: 'foreground',
}))`
  @media (max-width: ${BP_LAPTOP}px) {
    padding: 20px 12px 12px 12px;
  }
`;

export const ResultsContainer = styled(Box).attrs(() => ({
  display: 'block',
  position: 'absolute',
  p: 0,
  my: '-10px',
  bg: 'background',
  color: 'secondaryText',
}))`
  overflow: hidden;
  list-style: none;
  border: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-radius: 4px;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  width: ${({ width }) => width}px;
  z-index: 20;
  max-width: ${({ maxWidth }) => maxWidth}px;
  box-shadow: ${({ theme }) =>
    `0px 5px 13px 0px ${theme.colors.lightLineDivider}`};
  @media (max-width: ${BP_LAPTOP}px) {
    width: calc(100vw - 24px);
    left: 12px;
    max-width: 100vw;
  }
  @media (max-width: ${BP_TABLET}px) {
    width: calc(100vw - 24px);
    left: 12px;
    max-width: 100vw;
  }
`;

export const ResultWrapper = styled(Box).attrs({
  horizontal: true,
  align: 'center',
  position: 'relative',
  width: '100%',
  cursor: 'pointer',
  padding: '10px 16px',
})`
  letter-spacing: normal;
  user-select: none;
  max-width: ${({ maxWidth }) => maxWidth}px;
  ${({ isHovered, theme }) =>
    isHovered && `background-color: ${theme.colors.highlights}`};

  &:hover {
    background-color: ${({ theme }) => theme.colors.highlights};
  }
  @media (max-width: ${BP_LAPTOP}px) {
    width: 748px;
  }
  @media (max-width: ${BP_TABLET}px) {
    width: 580px;
  }
`;

export const StyledText = styled(Text).attrs(() => ({
  inline: true,
}))`
  padding-left: ${({ isPinnedPopover }) => (isPinnedPopover ? '0' : '10px')};
`;
export const StyledPlaceName = styled(StyledText).attrs(() => ({
  size: 'normal',
  color: 'primaryText',
  fontWeight: 'bold',
}))``;
export const StyledAxonOfficerName = styled(StyledPlaceName)``;

export const StyledSecondaryAddr = styled(StyledText).attrs(
  ({ isPrimary }) => ({
    size: isPrimary ? 'normal' : 'small',
    fontWeight: isPrimary ? 'bold' : 'regular',
    color: isPrimary ? 'primaryText' : 'secondaryText',
  }),
)``;
export const RegionalAddr = styled(StyledText).attrs(() => ({
  color: 'secondaryText',
  size: 'small',
}))``;
export const StyledAxonBadgeNumber = styled(RegionalAddr)``;

export const PhoneNumber = styled(StyledText).attrs(() => ({
  size: 'normal',
  fontWeight: 'bold',
  color: 'primaryText',
}))``;

export const ResultTitle = styled(Text).attrs({
  color: 'secondaryLink',
  size: 'small',
  padding: '10px',
})``;

export const ErrorText = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
  py: 1,
})``;

export const NoResultText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
  fontWeight: 'bold',
  px: 2,
})``;

export const SearchButton = styled(Button).attrs(() => ({}))`
  border: none;
  border-radius: 4px 0 0 4px;
  background: none;
  width: 50px;
  height: 36px;
  position: relative;

  &:active {
    border: none;
  }

  @media (max-width: ${BP_LAPTOP}px) {
    left: 0;
  }
`;

export const InputStyleWrapper = styled(Box).attrs({})`
  @media (max-width: ${BP_LAPTOP}px) {
    justify-content: flex-start;
    width: 100%;
  }
`;

export const IconWrapper = styled(Box).attrs(({ mr }) => ({
  mr: mr || '2px',
  color: 'secondaryLink',
}))``;

export const OverflowWrapper = styled(Box).attrs({})`
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;
